import React from "react";
import DashboardLayout from "../../../templates/dashboard-template";
import OrderTable from "../../../components/Table/Order/OrderTable";
// NAV TAB
import OrderNav from "../../../components/Table/Order/Navigation/OrderNav";
// Pagination
import OrderPagination from "../../../components/Table/Order/Pagination/Pagination";
// FILTERS
import Filters from "../../../components/Table/Order/Filters/Filters";
import ActiveFilters from "../../../components/Table/Order/ActiveFilters/activeFilters";
import { useTranslation } from "react-i18next";
// Search
import SearchOrder from "../../../components/Table/Order/Search/search";

const OrdersPage = () => {
  const [t, i18n] = useTranslation("common");

  return (
    <DashboardLayout>
      <div className="page-header-title">
        <h5 className="mt-3 mb-3">{t("app.Orders")}</h5>
      </div>
      <div className="page-container">
        <div className="page-container-header">
          <div className="col-8">
            <div className="row">
              <div className="col-md-5">
                <OrderNav />
              </div>
              <div className="col">
                <SearchOrder />
              </div>
            </div>
          </div>
          <div className="col-4">
            <OrderPagination />
          </div>
        </div>
        <div className="page-container-filter-bar">
          <div className="form-inline filter-form">
            <Filters />
          </div>
        </div>
        <ActiveFilters />
        <OrderTable />
      </div>
    </DashboardLayout>
  );
};
export default OrdersPage;
